import { Alert, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { AuthLayout } from "@src/components/modules/auth/layout";
import { getQueryParamOptional } from "@src/utils/routing";
import { useRouter } from "next/router";
import type { FunctionComponent } from "react";

export const TwoFASuccess: FunctionComponent = () => {
  const router = useRouter();

  return (
    <AuthLayout>
      <VStack align="start" spacing="4">
        <Alert status="success">
          <Trans>Two factor authentication confirmed.</Trans>
        </Alert>
        <HStack>
          <Text>
            <Trans>Your are logged in!</Trans>
          </Text>
          <Button
            onClick={() => {
              const redirect_to = getQueryParamOptional(
                "redirect_to",
                router.query,
              );

              // We need to make hard reload to reset the state of the app.
              window.location.href = redirect_to ?? "/";
            }}
          >
            <Trans>Take me back to app</Trans>
          </Button>
        </HStack>
      </VStack>
    </AuthLayout>
  );
};
